import TipsVideoPresentationComponent from "./TipsVideoPresentationComponent";

export default TipsVideoPresentationComponent;